import { MobileWarning } from '@/common/components/MobileWarning';
import { useLoadingPage } from '@/common/hooks/useLoadingPage';
import * as Sentry from '@sentry/react';
import { isMobile } from 'react-device-detect';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import PrivateRoute from './common/components/PrivateRoute';
import PublicCompanyRoute from './common/components/PublicCompanyRoute';
import Layout from './common/Layout';
import { privateCompanyRoutes, publicCompanyRoutes, publicRoutes } from './routes';
import InternalRouter from './common/components/InternalRouter';

import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
  useLoadingPage()

  if (isMobile) return <MobileWarning />

  return (
    <div>
      <BrowserRouter>
        <InternalRouter>
          <SentryRoutes>
            {publicRoutes.map((route) => (
              <Route path={route.path} Component={route.comp} key={route.path} />
            ))}

            <Route element={<PublicCompanyRoute />}>
              {publicCompanyRoutes.map((route) => (
                <Route path={route.path} Component={route.comp} key={route.path} />
              ))}
            </Route>

            <Route element={<PrivateRoute />}>
              <Route element={<Layout />}>
                {privateCompanyRoutes.map((route) => (
                  <Route path={route.path} Component={route.comp} key={route.path} />
                ))}
              </Route>
            </Route>
          </SentryRoutes>
        </InternalRouter>
      </BrowserRouter>
    </div>
  );
}

export default App;
